export default __webpack_public_path__ + "static/media/me.bb1b3535.png";